import React, { lazy } from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { Crown, CheckCircle2, Zap, Download, ShieldCheck, Sparkles, Star } from 'lucide-react';
export function SistemaCompleto() {
  const includes = ['Incluye Amazon FBA paso a paso', 'Incluye Amazon FBM paso a paso', 'Aprende a usar Seller Central desde cero', 'Aprende a publicar productos correctamente', 'Aprende campañas publicitarias dentro de Amazon', 'Aprende a encontrar productos ganadores', 'Incluye herramientas y estrategias con IA', 'Incluye bonos premium exclusivos'];
  const goToCheckout = () => {
    window.open('https://43skvt-1y.myshopify.com/products/sistema-completo-de-ventas-en-amazon-fba-fbm-2026', '_blank', 'noopener,noreferrer');
  };
  return <section className="bg-brand-green py-14 md:py-20 px-4 sm:px-6 relative overflow-hidden" data-id="element-690">
      {/* Decorative background */}
      <div className="absolute inset-0 overflow-hidden opacity-20 pointer-events-none" data-id="element-691">
        <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[700px] h-[700px] bg-brand-gold rounded-full blur-3xl" data-id="element-692"></div>
        <div className="absolute -bottom-32 -right-32 w-[400px] h-[400px] bg-brand-gold/60 rounded-full blur-3xl" data-id="element-693"></div>
      </div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-694">
        <FadeIn data-id="element-695">
          <div className="text-center mb-6 md:mb-8" data-id="element-696">
            {/* Premium badge */}
            <div className="inline-flex items-center justify-center gap-2 bg-brand-gold/15 border border-brand-gold/40 rounded-full px-5 py-2 mb-6" data-id="element-697">
              <Crown className="w-4 h-4 text-brand-gold" data-id="element-698" />
              <span className="text-xs font-bold tracking-widest text-brand-gold uppercase" data-id="element-699">
                La mejor decisión
              </span>
            </div>

            <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-5 leading-[1.05] tracking-tight" data-id="element-700">
              El sistema más completo para aprender{' '}
              <span className="text-brand-gold" data-id="element-701">Amazon FBA + FBM</span> desde
              cero
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-white/75 max-w-3xl mx-auto leading-relaxed" data-id="element-702">
              Todo lo que necesitas para aprender cómo funciona{' '}
              <span className="font-semibold text-brand-gold" data-id="element-703">
                Amazon Seller Central
              </span>
              , encontrar productos ganadores y comenzar a desarrollar una
              habilidad digital real desde casa.
            </p>
          </div>
        </FadeIn>

        {/* Mockup of the two books — HERO IMAGE */}
        <FadeIn delay={0.1} data-id="element-704">
          <div className="flex flex-col items-center mb-10 md:mb-14" data-id="element-705">
            {/* Small text above image */}
            <p className="text-[11px] sm:text-xs font-bold uppercase tracking-[0.2em] text-brand-gold mb-4 text-center" data-id="element-706">
              ⚡ Incluye Amazon FBA + FBM en un solo sistema
            </p>

            {/* Image with glow */}
            <div className="relative w-full max-w-[680px]" data-id="element-707">
              {/* Outer golden glow */}
              <div className="absolute inset-0 bg-brand-gold/25 blur-3xl rounded-[40px] scale-95" data-id="element-708"></div>
              {/* Inner soft glow */}
              <div className="absolute inset-0 bg-white/10 blur-2xl rounded-3xl" data-id="element-709"></div>

              <img src="https://cdn.magicpatterns.com/uploads/m8TmzqT4Ms73kvuSLyKdxi/ChatGPT_Image_16_may_2026,_10_00_02.png" alt="Sistema Completo Amazon FBA + FBM - Los dos cursos completos" loading="lazy" className="relative w-full h-auto rounded-2xl md:rounded-3xl shadow-[0_30px_80px_-10px_rgba(0,0,0,0.6)] ring-1 ring-white/10 object-contain" data-id="element-710" />
            </div>
          </div>
        </FadeIn>

        {/* Main premium card */}
        <FadeIn delay={0.15} data-id="element-711">
          <div className="relative" data-id="element-712">
            {/* Floating "MÁS POPULAR" badge */}
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 z-20" data-id="element-713">
              <div className="flex items-center gap-1.5 bg-brand-gold text-brand-green font-bold text-xs sm:text-sm uppercase tracking-widest px-5 sm:px-7 py-2 sm:py-2.5 rounded-full shadow-2xl shadow-brand-gold/40 ring-2 ring-brand-green whitespace-nowrap" data-id="element-714">
                <Star className="w-3.5 h-3.5 fill-brand-green" data-id="element-715" />
                Más Popular
                <Star className="w-3.5 h-3.5 fill-brand-green" data-id="element-716" />
              </div>
            </div>

            {/* Outer glow */}
            <div className="absolute inset-0 bg-brand-gold/20 blur-2xl rounded-3xl" data-id="element-717"></div>

            <div className="relative bg-white rounded-2xl md:rounded-3xl p-6 sm:p-8 md:p-12 shadow-[0_30px_80px_-15px_rgba(200,169,106,0.5)] border-2 md:border-4 border-brand-gold overflow-hidden" data-id="element-718">
              {/* Inner gold accent top */}
              <div className="absolute top-0 left-0 right-0 h-2 bg-gradient-to-r from-brand-gold/40 via-brand-gold to-brand-gold/40" data-id="element-719"></div>

              {/* Includes */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4 mb-8 md:mb-10 mt-4" data-id="element-720">
                {includes.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-721">
                    <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-722" />
                    <span className="text-base md:text-lg text-brand-text/85 font-medium leading-snug" data-id="element-723">
                      {item}
                    </span>
                  </div>)}
              </div>

              {/* Value highlight */}
              <div className="bg-gradient-to-br from-brand-beige/80 to-brand-beige/40 border border-brand-gold/20 rounded-2xl px-6 py-6 mb-8 text-center" data-id="element-724">
                <Sparkles className="w-6 h-6 text-brand-gold mx-auto mb-2" data-id="element-725" />
                <p className="text-xs uppercase tracking-widest text-brand-text/60 font-semibold mb-1" data-id="element-726">
                  Valor total real
                </p>
                <p className="text-3xl md:text-4xl font-bold text-brand-green" data-id="element-727">
                  MÁS DE $337 EN VALOR REAL
                </p>
              </div>

              {/* Price — premium presentation */}
              <div className="text-center mb-8" data-id="element-728">
                <p className="text-base md:text-lg text-brand-text/40 mb-1" data-id="element-729">
                  ANTES{' '}
                  <span className="line-through font-semibold" data-id="element-730">$31.65</span>
                </p>
                <p className="text-xs font-semibold uppercase tracking-widest text-brand-text/50 mb-2" data-id="element-731">
                  🔥 Hoy solo
                </p>
                <p className="text-6xl sm:text-7xl md:text-8xl font-bold text-brand-green mb-3 tracking-tight leading-none" data-id="element-732">
                  $27.99
                </p>
                <div className="inline-block bg-brand-gold/15 border border-brand-gold/40 rounded-full px-4 py-1.5 mb-3" data-id="element-733">
                  <p className="text-xs sm:text-sm font-bold text-brand-green uppercase tracking-wider" data-id="element-734">
                    ⚡ Oferta especial de lanzamiento
                  </p>
                </div>
                <p className="text-sm md:text-base text-brand-green font-semibold" data-id="element-735">
                  🔥 Ahorra más comprando el Sistema Completo FBA + FBM
                </p>
              </div>

              {/* CTA */}
              <div className="flex flex-col items-center" data-id="element-736">
                <Button onClick={goToCheckout} className="w-full bg-brand-gold hover:bg-brand-gold/90 text-brand-green text-base sm:text-lg md:text-xl font-bold px-8 sm:px-12 py-5 sm:py-6 shadow-2xl shadow-brand-gold/40 ring-2 ring-brand-gold/30 tracking-wide" data-id="element-737">
                  🚀 QUIERO EL SISTEMA COMPLETO FBA + FBM
                </Button>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-brand-text/50 text-xs mt-5" data-id="element-738">
                  <span className="flex items-center gap-1.5" data-id="element-739">
                    <Zap className="w-3.5 h-3.5 text-brand-green" data-id="element-740" />
                    ACCESO INMEDIATO
                  </span>
                  <span className="flex items-center gap-1.5" data-id="element-741">
                    <Download className="w-3.5 h-3.5 text-brand-green" data-id="element-742" />
                    DESCARGA DIGITAL
                  </span>
                  <span className="flex items-center gap-1.5" data-id="element-743">
                    <ShieldCheck className="w-3.5 h-3.5 text-brand-green" data-id="element-744" />
                    COMPRA SEGURA
                  </span>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}